import { useCallback } from 'react';

import { useNavigate } from '@change-corgi/core-react/router';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { usePromoteOrShareActionUrls } from '../../../usePromoteOrShareActionUrls';

export function useOnShareFailure(): ShareActionsOptions<ShareChannel>['onFailure'] {
	const {
		data: { shareButtonUrl: redirectUrl },
	} = usePromoteOrShareActionUrls();
	const navigate = useNavigate();
	const {
		userAgent: { isWebview },
	} = useUtilityContext();
	const {
		data: { psfComboRemoveAutoProgressionExperiment },
	} = usePsfPromoteOrSharePageData();

	const { variation: autoProgressionVariation } = psfComboRemoveAutoProgressionExperiment;
	const skipSocialRedirect = autoProgressionVariation === 'variant_2' || autoProgressionVariation === 'variant_3';

	return useCallback(
		(channel: ShareChannel) => {
			// webviews do not allow opening in new tab, which most share actions attempt to do
			// instead they attempt to open in the current tab, which if overridden by this redirect
			// so this disables the redirect in order to be able to share
			if (channel !== 'mobileNativeShare' || isWebview) return;
			if (skipSocialRedirect) return;

			navigate(redirectUrl);
		},
		[redirectUrl, navigate, isWebview, skipSocialRedirect],
	);
}
